const config = {
  name: '$http',
  general: '/api',
  static: '/'
}

export default config
